<template>
  <img src="@/assets/img/SepticTank.svg" />
</template>

<script>
export default {}
</script>

<style></style>
